module.exports = __webpack_public_path__ + "static/media/gateway.0b11c981.png";